import { defineMessages } from 'react-intl'

export default defineMessages({
  pagination: {
    id: 'Table.Pagination',
    defaultMessage: 'Displaying {start} to {end} of {total} {type}'
  }
})
